import { Avatar } from 'module/ui/components/atoms/avatar';
import styled from 'styled-components';

export const CardWrapper = styled.div`
  padding: var(--spacing-06) 0;
  border-radius: var(--border-radius-small);
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
  margin-bottom: var(--spacing-04);
`;

export const TypeIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;

export const PersonInfo = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;

export const PersonMeta = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TaskTable = styled.div`
  margin-top: var(--spacing-05);
`;

export const TaskRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: var(--spacing-03);
  padding: var(--spacing-03) 0;
  border-bottom: 1px solid var(--gray-10);
`;

export const TaskHeader = styled(TaskRow)`
  color: var(--gray-70);
`;

export const InsightfulCount = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
  color: var(--gray-70);
  margin-top: var(--spacing-05);

  svg {
    color: var(--orange-40);
  }
`;

export const ReasonForSignalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);
  /* padding-top: var(--spacing-03); */
  padding-bottom: var(--spacing-03);
`;

export const SignalMainContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: var(--spacing-05);
  padding-bottom: var(--spacing-05);
  gap: var(--spacing-03);
`;

export const StyledPeopleList = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;

export const AvatarStack = styled.div`
  position: relative;
  width: 52px;
  height: 36px;
`;

export const BaseAvatar = styled(Avatar)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

export const CountAvatar = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--gray-20);
  color: var(--gray-100);
  font-size: var(--font-size-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--white-100);
  z-index: 2;
`;

export const PlaceholderUserNames = styled.div`
  color: #6f6f6f;
  font-size: var(--font-size-sm);
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
`;

export const PlaceholderDate = styled.div`
  color: #a8a8a8;

  /* Utility/Label 01 */
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
`;

export const PeopleNames = styled.div`
  color: var(--gray-100);
  font-size: var(--font-size-base);
`;
